// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  scrollbar-color: rgb(27, 27, 27);

  &::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  &::-webkit-scrollbar-track {
    background: rgb(27, 27, 27);
  }

  &::-webkit-scrollbar-thumb {
    background: #424242;
    outline: 1px solid #333;
  }

  &::-webkit-scrollbar-corner {
    background: rgb(27, 27, 27);
  }
}

html {
  overflow-x: hidden;
}

body {
  background-color: #151515;
  margin: 0;
  padding: 0;
  color: #ddd;
  height: 100vh;
}

#content {
  width: 100%;
}

main#content {
  left: 0;
  top: 32px;
  position: absolute;
}

a {
  color: #ff2e88;
}

a:visited {
  color: #a89984;
}

button {
  background-color: rgb(54, 54, 54);
  color: rgb(161, 161, 161);
  border: none;
  outline: 1px transparent;
  font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;
  cursor: pointer;
  font-size: 15px;
  padding: 3px 8px;
}

input[type='text'],
input[type='number'],
input[type='password'],
textarea {
  border: 1px solid #666;
  background-color: #191919;
  border: 1px solid #979797;
  outline: none;
  color: #ccc;
}

button:disabled {
  background-color: rgb(78, 78, 78);
  color: rgb(133, 133, 133);
  cursor: default;
}

.control-panel button {
  font-size: 13.25px;
}

select {
  height: 20px;
  border: none;
  border-radius: 0px;
  outline: none;
  background-color: rgb(54, 54, 54);
  color: rgb(161, 161, 161);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;;EAEhC;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,OAAO;EACP,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,YAAY;EACZ,wBAAwB;EACxB,oEAAoE;EACpE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,yBAAyB;AAC3B","sourcesContent":["* {\n  scrollbar-color: rgb(27, 27, 27);\n\n  &::-webkit-scrollbar {\n    width: 12px;\n    height: 12px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgb(27, 27, 27);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #424242;\n    outline: 1px solid #333;\n  }\n\n  &::-webkit-scrollbar-corner {\n    background: rgb(27, 27, 27);\n  }\n}\n\nhtml {\n  overflow-x: hidden;\n}\n\nbody {\n  background-color: #151515;\n  margin: 0;\n  padding: 0;\n  color: #ddd;\n  height: 100vh;\n}\n\n#content {\n  width: 100%;\n}\n\nmain#content {\n  left: 0;\n  top: 32px;\n  position: absolute;\n}\n\na {\n  color: #ff2e88;\n}\n\na:visited {\n  color: #a89984;\n}\n\nbutton {\n  background-color: rgb(54, 54, 54);\n  color: rgb(161, 161, 161);\n  border: none;\n  outline: 1px transparent;\n  font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;\n  cursor: pointer;\n  font-size: 15px;\n  padding: 3px 8px;\n}\n\ninput[type='text'],\ninput[type='number'],\ninput[type='password'],\ntextarea {\n  border: 1px solid #666;\n  background-color: #191919;\n  border: 1px solid #979797;\n  outline: none;\n  color: #ccc;\n}\n\nbutton:disabled {\n  background-color: rgb(78, 78, 78);\n  color: rgb(133, 133, 133);\n  cursor: default;\n}\n\n.control-panel button {\n  font-size: 13.25px;\n}\n\nselect {\n  height: 20px;\n  border: none;\n  border-radius: 0px;\n  outline: none;\n  background-color: rgb(54, 54, 54);\n  color: rgb(161, 161, 161);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
